import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock, LogIn } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { toast } from 'sonner';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminLogin() {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  // If already logged in, redirect
  if (localStorage.getItem('hke_admin_token')) {
    navigate('/admin/dashboard');
    return null;
  }

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await axios.post(`${API}/admin/login`, { username, password });
      localStorage.setItem('hke_admin_token', res.data.token);
      toast.success('Erfolgreich angemeldet');
      navigate('/admin/dashboard');
    } catch {
      toast.error('Ungültige Anmeldedaten');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F8FAFC] flex items-center justify-center px-4" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="w-16 h-16 bg-[#0077D4] flex items-center justify-center mx-auto mb-4">
            <Lock size={28} className="text-white" />
          </div>
          <h1 className="font-heading text-2xl font-bold text-slate-900 uppercase tracking-wider">Admin Panel</h1>
          <p className="text-slate-500 text-sm mt-2">HKE Bedachung Ertel</p>
        </div>

        <form onSubmit={handleLogin} className="bg-white border border-slate-200 p-8 space-y-6" data-testid="admin-login-form">
          <div>
            <Label htmlFor="username" className="text-slate-700 font-medium text-sm">Benutzername</Label>
            <Input
              id="username"
              value={username}
              onChange={e => setUsername(e.target.value)}
              placeholder="admin"
              className="mt-2 rounded-none border-slate-300 h-12 bg-slate-50"
              data-testid="admin-username-input"
            />
          </div>
          <div>
            <Label htmlFor="password" className="text-slate-700 font-medium text-sm">Passwort</Label>
            <Input
              id="password"
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="Passwort"
              className="mt-2 rounded-none border-slate-300 h-12 bg-slate-50"
              data-testid="admin-password-input"
            />
          </div>
          <Button
            type="submit"
            disabled={loading}
            className="w-full bg-[#0077D4] hover:bg-[#005BA8] text-white rounded-none h-12 font-bold uppercase tracking-wider inline-flex items-center justify-center gap-2"
            data-testid="admin-login-button"
          >
            <LogIn size={18} />
            {loading ? 'Anmelden...' : 'Anmelden'}
          </Button>
        </form>

        <p className="text-center text-slate-400 text-xs mt-6">
          <a href="/" className="hover:text-[#0077D4] transition-colors">Zurück zur Webseite</a>
        </p>
      </div>
    </div>
  );
}
